import { map, omit, concat } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_USERS} from 'vx/mutations'



// User state.
const state = {
  users: []
}

// User state getters.
const getters = {
  /**
   * User state as a decorated object.
   */
  users: state => state.users,

  getById: (state) => (id) => {
    return state.users.find(user => user.id === id)
  }
}

// User actions.
const actions = {

  /**
   * Get a list of users.
   */
  getUsers ({ commit }, payload) {
    return http.get(`/users/list`).then(response => {
      commit(SET_USERS, response.data)

      return response
    })
  },
}

// User state mutations.
const mutations = {
  
  /**
  * Set the users state.
  */
  [SET_USERS] (state, users) {
    state.users = users
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
